/** Existing carryonpan app only; never infer identity from a shared Toss suffix. */
export const TOSS_APP_ORIGINS = [
  'https://carryonpan.apps.tossmini.com',
  'https://carryonpan.private-apps.tossmini.com',
  'https://carryonpan.web.tossmini.com',
] as const;
export function isCarryonpanTossHost(hostname: string): boolean {
  return TOSS_APP_ORIGINS.some((origin) => new URL(origin).hostname === hostname.toLowerCase());
}
